import { Paper, BottomNavigation, ThemeProvider, Box } from '@mui/material';
import { ReactNode } from 'react';
import { useComposeTheme } from '@theme/theme';
import { FontSize } from '@store/types/UserStoreSlice.type';

type TBottomNavMenu = {
  children: ReactNode[] | ReactNode;
  height?: number;
};
export const BottomNavManu = ({ children, height }: TBottomNavMenu) => {
  const themeToUse = useComposeTheme('dark', { fontSizeOverride: FontSize.DEFAULT });
  return (
    <>
      {/* Due to the fixed position of the paper/buttom element we need to "allow height" for it so the page can still scroll behind */}
      <Box
        sx={{
          height: height ?? 90,
        }}
      />
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderRadius: '0',
          padding: 1,
          zIndex: 1,
          backgroundColor: 'primary.main',
        }}
        elevation={3}
      >
        <ThemeProvider theme={themeToUse}>
          <BottomNavigation sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: 'transparent' }}>
            {children}
          </BottomNavigation>
        </ThemeProvider>
      </Paper>
    </>
  );
};
